
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"14","viewBox":"0 0 12 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 13.74V.058h.274c.221 0 .873-.007 1.954-.02A115.28 115.28 0 014.319 0c2.58 0 4.502.638 5.766 1.915C11.362 3.192 12 4.815 12 6.782c0 2.02-.684 3.694-2.052 5.023-1.355 1.316-3.284 1.973-5.785 1.973-.196 0-.762-.006-1.7-.019-.939-.013-1.649-.02-2.13-.02H0zM4.28 2.931c-.508 0-.892.02-1.153.058v7.818c.274.026.652.039 1.134.039 1.368 0 2.443-.352 3.224-1.055.795-.717 1.193-1.72 1.193-3.01 0-1.225-.404-2.17-1.212-2.834-.808-.678-1.87-1.016-3.186-1.016z","fill":"#ADA3BF"}})])
          )
        }
      }
    